export default (strings, ...values) => strings.reduce((compiled, string, index) => {
  if (!values[index]) {
    return compiled.concat(string);
  }
  return compiled.concat(string, encodeURIComponent(values[index]));
}, []).join('');
